import type { SharedProps } from 'baseui/input';
import type { StyleObject } from 'styletron-react';

import type { InputProps } from './Input';

import theme from 'theme';

export function getDefaultKindStyles(
  kind: InputProps['kind'],
  sharedProps: SharedProps,
): StyleObject {
  const { $isFocused, $error } = sharedProps;

  switch (kind) {
    case 'primary':
      return Object.freeze({});
    case 'secondary':
      return {
        backgroundColor: theme.colors.white,
        borderBottomColor: theme.colors.mono400,
        borderLeftColor: 'transparent',
        borderTopColor: 'transparent',
        borderRightColor: 'transparent',
        borderBottomLeftRadius: '0',
        borderBottomRightRadius: '0',
        ...($isFocused
          ? {
              borderBottomColor: theme.colors.primary,
            }
          : {}),
        ...($error
          ? {
              borderBottomColor: theme.colors.negative,
            }
          : {}),
      };
    case 'tertiary':
      return {
        backgroundColor: 'transparent',
        borderBottomColor: 'transparent',
        borderLeftColor: 'transparent',
        borderTopColor: 'transparent',
        borderRightColor: 'transparent',
        borderBottomLeftRadius: '0',
        borderBottomRightRadius: '0',
        ...($isFocused
          ? {
              backgroundColor: 'transparent',
            }
          : {}),
        ...($error
          ? {
              borderBottomColor: theme.colors.backgroundNegative,
            }
          : {}),
      };
    default:
      return Object.freeze({});
  }
}
